/**
 * 根据操作系统获取默认下载路径
 * @returns {string} 默认下载路径
 */
export function getDefaultDownloadPath() {
  const folderName = '屿智同行千寻AI招聘平台';
  
  // 检测操作系统
  const platform = navigator.platform || navigator.userAgent;
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Windows 系统
  if (platform.includes('Win') || userAgent.includes('win')) {
    return `D:\\${folderName}`;
  }
  
  // macOS 系统
  if (platform.includes('Mac') || userAgent.includes('mac')) {
    // macOS 使用 ~/Downloads/ 路径
    return `~/Downloads/${folderName}`;
  }
  
  // Linux 系统
  if (platform.includes('Linux') || userAgent.includes('linux')) {
    return `~/Downloads/${folderName}`;
  }
  
  // 默认情况（未知系统，使用 macOS/Linux 格式）
  return `~/Downloads/${folderName}`;
}



